export const homePage = {
  signIn: 'Sign in',
  myProject: 'My projects',
  scheduleDemo: 'Schedule demo',
  jumbotron: {
    marker: [
      'Really',
      'Simple',
      'Reporting',
    ],
    paragraph1: 'Akvo Really Simple Reporting (RSR) is an online data platform where all your planning, monitoring, evaluation and learning (PMEL) processes come together.',
    paragraph2: 'Monitor the results of your projects in one platform, in a shared format that everyone in your team understands.',
  },
  howItWorks: 'How it works',
  monitorTheImpact: {
    title: 'Monitor the impact of your projects',
    description: 'RSR reduces the reporting burdens of PMEL teams, making it easier for everyone working on a project to regularly report on the results they’ve achieved, assess progress, and steer projects to success.'
  },
  features: 'Features',
  featureItems: [
    'Define indicators at programme and project level',
    'Work with qualitative and quantitative indicators',
    'Ensure data integrity by working with a single, core results framework',
    'Aggregate indicator results from projects and programmes',
    'Monitor and assess your projects using a simple web interface',
    'Create reports using our templates in Excel, Word or PDF',
    'Easily report to IATI without any coding Connect RSR with other tools',
  ],
  activeProject: 'Active projects',
  trustedPartner: 'Trusted partners',
  contactUs: {
    title: 'Contact us to schedule a demo',
    description: 'Schedule a demo and let our expert team show you how to make the most of your project data using Akvo\'s Really Simple Reporting',
    cta: 'Request demo'
  },
  exploreCaseStudy: 'Explore the case study',
}
